import axios from '@/services/request';
import axios2, { AxiosRequestConfig } from 'axios';
import {AxiosPromise} from "axios";
import store from "@/store";
import {PageInfo, Resp} from "@/model/Resp";
import {SignReq, PMS} from "@/model/Req";
import {SignUpReq, UserInfo, UserInfoReq} from "@/model/UserInfo";
import SparkMD5 from 'spark-md5'
import {
  CallbackReq,
  CallbackReqShoplazza,
  CallbackReqShopline,
  GuideDetail,
  GuideSaveCompanyReq,
  GuideSaveTemplateReq
} from "@/model/Guide";
import {Contact} from "@/model/Contact";
import {IntegrationMap} from "@/model/Integration";
import {FlowDetailVO, TFlowVO} from "@/model/FlowDetailVO";
import {FlowConfigVO} from "@/model/FlowConfigVO";
import {FenqunPageInfo, TFenqunDetailVO, TFenqunRecordVO, TFenqunUserInfoVO, TFenqunVO} from "@/model/TFenqunVO";
import {EcharsDimension, EmailSendReq, ListBy, Style, StyleInfo} from "@/model/first";
import {SubscribeReq, SubscribeResp} from "@/model/Subscribe";
import {TCampaignIDRequest, TCampaignSaveDetailRequest, TCampaignVO} from "@/model/Campaign";
import {TFormSaveDetailRequest, TFormVO, TTabAuthVO} from "@/model/FormWheel";
import {SubscriptionPlanData, SubscriptionPlanReq, SubscriptionPlanResp} from "@/model/Subscription";
import { Log500Error, LogRequestInfo, LogTimeoutError } from './cartxLog';
import {MessageBox, Message} from "element-ui";
import { isEnableNewService } from '@/utils/experiment';
import { getVueAppBaseApi } from './util';
import i18n from '@/i18n';

const service2 = axios2.create({
  baseURL: isEnableNewService() ? 'https://static-forms.clink-lists.com' : 'https://cartsee-form-c.cartx.cloud', // url = base url + request url
  // withCredentials: true, // 如跨域请求时要带上cookies,则设置为true
  timeout: 120000, // 请求超时时长
});

service2.interceptors.request.use(
  (config: any) => {
    // 在发送请求之前做些什么
    config.cartxTime = performance?.now() || Date.now();
    return config;
  },
  (error: any) => {
    console.error(error);
    store.commit('SET_LOADING', false);
    return Promise.reject(error);
  },
);

service2.interceptors.response.use(
  (response) => {
    const config:any = response?.config;
    if (config?.cartxTime) {
      const t = performance?.now() || Date.now();
      const duration = t - config?.cartxTime;
      // console.log('reqeust duration', t - response?.config?.cartxTime);
      LogRequestInfo({
        ru:response.config?.url||(response.request?.custom?.url||''), // request url
        rp:response.config?.data||(response.request?.custom?.options?.body||''), // request params
        ru1:response.request?.responseURL||'', // response url
        m:response.config?.method||'POST', // method
        em:response.status||'', // error message
        er:{code:response?.data?.code,message:response?.data?.message}||'', // error response
        time: duration,
      });
    }
    store.commit('SET_LOADING', false);
    // if(response.data && response.data.code === 401) {
    //   // 如果返回401 即没有权限，跳到登录页重新登录
    //   if(router.currentRoute.path !== '/login') {
    //     logFail();
    //   }
    //   return Promise.reject(new Error('Error'));
    // }
    if (!response.data || response.data.code !== 0) {
      Message.error({
        message: (response && response.data && response.data.message) || (i18n.t('services.api.text_7f517edc8bf76c42') as string),
        center: true
      })
      return Promise.reject(new Error(response && response.data && response.data.message|| 'Error'));
    }
    return response;
  },
  (error) => {
    if (error?.config?.cartxTime) {
      const t = performance?.now() || Date.now();
      const duration = t - error?.config?.cartxTime;
      // console.log('reqeust duration', t - response?.config?.cartxTime);
      LogRequestInfo({
        ru:error.config?.url||(error.request?.custom?.url||''), // request url
        rp:error.config?.data||(error.request?.custom?.options?.body||''), // request params
        ru1:error.request?.responseURL||'', // response url
        m:error.config?.method||'POST', // method
        em:error.message||(error.status||error.status?.status), // error message
        er:error.response?.data||'', // error response
        time: duration,
      });
    }
    store.commit('SET_LOADING', false);
    if(error.response) {
      // if(error.response.data.code === 401) {
      //   // 如果返回401 即没有权限，跳到登录页重新登录
      //   if(router.currentRoute.path !== '/login') {
      //     logFail();
      //   }
      //   return Promise.reject(error);
      // }
    }

    if (error.request && error.request.readyState == 4 && error.request.status >= 500) {
      // 500 以上的服务器请求，触发埋点上报:
      Log500Error({
        ru:error.config?.url||(error.request?.custom?.url||''), // request url
        rp:error.config?.data||(error.request?.custom?.options?.body||''), // request params
        ru1:error.request?.responseURL||'', // response url
        m:error.config?.method||'POST', // method
        em:error.message||(error.status||'500+'), // error message
        er:error.response?.data||'', // error response
      });
    }


    if (error?.message?.includes('timeout')) {
      // 报个超时状态出去
      LogTimeoutError({
        ru:error.config?.url||(error.request?.custom?.url||''), // request url
        rp:error.config?.data||(error.request?.custom?.options?.body||''), // request params
        ru1:error.request?.responseURL||'', // response url
        m:error.config?.method||'POST', // method
        em:error?.message||(error?.status||error.request?.status||'504'), // error message
        er:error.response?.data||'', // error response
      });
    }
    Message.error({
      message: (error.response && error.response.data && error.response.data.message) || (i18n.t('services.api.text_7f517edc8bf76c42') as string),
      center: true
    })
    return Promise.reject(error);

  },
);

export function sign(pms: PMS, token: string): SignReq {
  const paramsStr = JSON.stringify(pms);
  const sign = SparkMD5.hash(paramsStr + token);
  return {
    ts:Math.round(new Date().getTime()/1000),
    pms: JSON.stringify(pms),
    sign
  }
}

export function getQueryVariable(variable: string) {
  const urlSearchParams = new URLSearchParams(location.search.replace("+", "%2B"));
  return urlSearchParams.get(variable) || '';
}

export const getCommonConfig = async (key:any) =>  {
  try {
    const url = isEnableNewService() ? 'https://op.cartsee.com/getnacos' : 'https://59b517704ce43f0f.cartx.cloud/getnacos';
    const method = 'post';
    const formData = new FormData();

    // 添加表单字段
    formData.append('key', key);

    const headers = {
      'Content-Type': 'multipart/form-data' // 使用form/data格式
    };

    const response = await axios({
      method,
      url,
      headers,
      data: formData
    });
    return response;

    // 处理响应数据
    // console.log(response.data);
  } catch (error) {
    // 处理错误
    console.error(error);
  }
}

/**
 * 获取版本信息
 */
export function getVersion() {
  return axios2.create({
    baseURL: '',
    timeout: 120000, // 请求超时时长
  }).get(`/version.json?ts=${Date.now()}`);
}

/**
 * 接口通用方法
 * @param params
 * @param action
 * @param showLoading
 * @param token
 */
export function commonApi(params: PMS, action: string, showLoading: boolean = false, token?: string): AxiosPromise<Resp<any>> {
  verifySessionAccount();

  token = getToken(token);
  const newParams = sign(params, token);
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api.json?action=${action}`, newParams,{headers: {token}})
}

/**
 * cartsee 业务接口 action 维护：本文件内通过 `commonApi(params, action)` → POST `/api.json?action={action}`。
 * 命名与仓库内既有接口一致，使用点分 `cartsee.{域}.{方法}`（同 cartsee-front 中 `cartsee/{域}/{方法}` 的 RPC）。
 */
const CARTSEE_COLLECTION_PRODUCT_ACTION = {
  collectionListByCompany: "cartsee.collection.listByCompany",
  /** 系列搜索；对齐 cartsee-front `cartsee/collection/listBySearch` */
  collectionListBySearch: "cartsee.collection.listBySearch",
  productListByCollection: "cartsee.product.listByCollection",
  /** 商品搜索；对齐 cartsee-front `cartsee/product/listBySearch` */
  productListBySearch: "cartsee.product.listBySearch",
} as const;

export function verifySessionAccount(){
  // 对比sessionStorage和localStorage的email
  const sessionEmail = JSON.parse(
    sessionStorage.getItem('sessionDisplayInfo')||'{}'
  ).email;
  const email = JSON.parse(
    localStorage.getItem('displayInfo')||'{}'
  ).email;
  if(sessionEmail && (sessionEmail !== email)) {
    if(window.location.pathname !== '/cartsee-new/login') {
      window.location.href = '/cartsee-new/login';
      return;
    }
  } else {
    sessionStorage.setItem('sessionDisplayInfo', localStorage.getItem('displayInfo')||'');
  }
}

export function mockApi(params: PMS, action: string, showLoading: boolean = false, token?: string): AxiosPromise<Resp<any>> {
  token = getToken(token);
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/cartsee-go${action}`, params,{headers: {token}})
}

export function getToken(token?: string): string {
  token = token || localStorage.getItem('token') || '';
  if (!token) {
    const state = getQueryVariable('state');
    if (state) {
      token = (state.match(new RegExp(`[0-9]+--[0-9]+--(.*$)`)) || ['', 'default'])[1];
      localStorage.setItem('token', token)
    } else {
      token = 'default';
    }
  }
  return token;
}
/**
 * 登录
 * @param params
 * @param showLoading
 */
export function login(params: UserInfoReq, showLoading: boolean = false): AxiosPromise<Resp<UserInfo>> {
  return commonApi(params, 'passport.login', showLoading);
}

/**
 * 登出
 * @param params
 * @param showLoading
 */
export function logout(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'passport.logout', showLoading);
}

/**
 * 注册
 * @param params
 * @param showLoading
 */
export function signUp(params: SignUpReq, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.init.collect.user', showLoading);
}

/**
 * shopify集成回调
 * @param params
 * @param showLoading
 */
export function callbackShopify(params: CallbackReq, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.callback.shopify', showLoading);
}
/**
 * shopline集成回调
 * @param params
 * @param showLoading
 */
export function callbackShopline(params: CallbackReqShopline, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.callback.shopline', showLoading);
}
/**
 * shoplazza集成回调
 * @param params
 * @param showLoading
 */
export function callbackShoplazza(params: CallbackReqShoplazza, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.callback.shoplazza', showLoading);
}

/**
 * 获取向导进度接口
 * @param params
 * @param showLoading
 */
export function getGuideDetail(params: {}, showLoading: boolean = false): AxiosPromise<Resp<GuideDetail>> {
  return commonApi(params, 'cartsee.guide.detail', showLoading);
}

/**
 * 添加品牌信息
 * @param params
 * @param showLoading
 */
export function setGuideSaveCompany(params: GuideSaveCompanyReq, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.guide.saveCompany', showLoading);
}

/**
 * 设置邮件模板
 * @param params
 * @param showLoading
 */
export function setGuideSaveTemplate(params: GuideSaveTemplateReq, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.guide.saveTemplate', showLoading);
}

/**
 * 保存自定义邮件模板
 * @param params
 * @param showLoading
 */
export function saveCompanyTemplate(params:{
    title: string,imageUrl: string,
    jsonContent: string,showSubscribeCode?: boolean,
    category?:string,
    couponCode?: string;}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.companyTemplate.saveDetail', showLoading);
}

/**
 * 获取联系人列表
 * @param params
 * @param showLoading
 */
export function getContactList(params: PageInfo, showLoading: boolean = true): AxiosPromise<Resp<Contact[]>> {
  return commonApi(params, 'cartsee.contact.list', showLoading);
}


/**
 * 集成列表
 * @param params
 * @param showLoading
 */
export function getIntegration(params: {}, showLoading: boolean = false): AxiosPromise<Resp<IntegrationMap>> {
  return commonApi(params, 'cartsee.integration.all', showLoading);
}

/**
 * 配置
 * @param params
 * @param showLoading
 */
export function getFlowConfig(params: {}, showLoading: boolean = false): AxiosPromise<Resp<FlowConfigVO>> {
  return commonApi(params, 'cartsee.flow.config', showLoading);
}

/**
 * 流程列表接口
 * @param params
 * @param showLoading
 */
export function getFlowList(params: PageInfo, showLoading: boolean = true): AxiosPromise<Resp<TFlowVO[]>> {
  return commonApi(params, 'cartsee.flow.list', showLoading);
}

/**
 * 流程列表接口
 * @param params
 * @param showLoading
 */
export function getFlowCount(params: {}, showLoading: boolean = true): AxiosPromise<Resp<number>> {
  return commonApi(params, 'cartsee.flow.countAll', showLoading);
}


/**
 * 流程详情接口
 * @param params
 * @param showLoading
 */
export function getFlowDetail(params: {id: number}, showLoading: boolean = false): AxiosPromise<Resp<FlowDetailVO>> {
  return commonApi(params, 'cartsee.flow.detail', showLoading);
}


/**
 * 流程详情接口 v2
 * @param params
 * @param showLoading
 */
export function getFlowDetail2(params: {id: number}, showLoading: boolean = false): AxiosPromise<Resp<FlowDetailVO>> {
  return commonApi(params, 'cartsee.flow.v2.detail', showLoading);
}

/**
 * 保存并发布流程详情
 * @param params
 * @param showLoading
 */
export function savePublishDetail(params: FlowDetailVO, showLoading: boolean = false): AxiosPromise<Resp<FlowDetailVO>> {
  return commonApi(params, 'cartsee.flow.savePublishDetail', showLoading);
}

/**
 * 保存流程详情
 * @param params
 * @param showLoading
 */
export function saveFlowDetail(params: FlowDetailVO, showLoading: boolean = false): AxiosPromise<Resp<FlowDetailVO>> {
  return commonApi(params, 'cartsee.flow.saveDetail', showLoading);
}

/**
 * 保存草稿流程详情
 * @param params
 * @param showLoading
 */
export function saveDraftDetail(params: FlowDetailVO, showLoading: boolean = false): AxiosPromise<Resp<FlowDetailVO>> {
  return commonApi(params, 'cartsee.flow.saveDraftDetail', showLoading);
}

/**
 * 复制流程
 * @param params
 * @param showLoading
 */
export function copyFlowDetail(params: {id: number}, showLoading: boolean = false): AxiosPromise<Resp<FlowDetailVO>> {
  return commonApi(params, 'cartsee.flow.detail.copy', showLoading);
}

/**
 * 暂停流程
 * @param params
 * @param showLoading
 */
export function pauseFlowDetail(params: {id: number}, showLoading: boolean = false): AxiosPromise<Resp<FlowDetailVO>> {
  return commonApi(params, 'cartsee.flow.detail.pause', showLoading);
}

/**
 * items联想列表
 */
export function getSuggestList(params: {
  type: string,
  emailTemplateType?:string,
  id?:number,
  value?: number}, showLoading: boolean = false): AxiosPromise<Resp<{id: string, name: string}[]>> {
  return commonApi(params, 'cartsee.suggest.value.search', showLoading);
}

/**
 * 启用流程
 * @param params
 * @param showLoading
 */
export function runFlowDetail(params: {id: number}, showLoading: boolean = false): AxiosPromise<Resp<FlowDetailVO>> {
  return commonApi(params, 'cartsee.flow.detail.run', showLoading);
}

/**
 * 删除流程
 * @param params
 * @param showLoading
 */
export function deleteFlowDetail(params: {id: number}, showLoading: boolean = false): AxiosPromise<Resp<FlowDetailVO>> {
  return commonApi(params, 'cartsee.flow.detail.delete', showLoading);
}

/**
 * 用户群列表--进行中
 * @param params
 * @param showLoading
 */
export function getFenqunList(params: PageInfo, showLoading: boolean = false): AxiosPromise<Resp<TFenqunVO[]>> {
  return commonApi(params, 'cartsee.fenqun.list', showLoading);
}
/**
 * 用户群列表--统计
 * @param params
 * @param showLoading
 */
export function getFenqunAvailableList(params: PageInfo, showLoading: boolean = false): AxiosPromise<Resp<TFenqunVO[]>> {
  return commonApi(params, 'cartsee.fenqun.available.list', showLoading);
}

/**
 * 用户群详情
 * @param params
 * @param showLoading
 */
export function getFenqunDetail(params: {id: number}, showLoading: boolean = false): AxiosPromise<Resp<TFenqunDetailVO>> {
  return commonApi(params, 'cartsee.fenqun.detail', showLoading);
}

/**
 * 用户群保存
 * @param params
 * @param showLoading
 */
export function saveFenqunDetail(params: TFenqunDetailVO, showLoading: boolean = false): AxiosPromise<Resp<TFenqunDetailVO>> {
  return commonApi(params, 'cartsee.fenqun.saveDetail', showLoading);
}

/**
 * 用户群更新
 * @param params
 * @param showLoading
 */
export function updateFenqunDetail(params: {fenqunId: number; name: string}, showLoading: boolean = false): AxiosPromise<Resp<TFenqunDetailVO>> {
  return commonApi(params, 'cartsee.fenqun.list.update', showLoading);
}

/**
 * 校验用户分群是否可以删除
 * @param params
 * @param showLoading
 */
export function verifyFenqun(params: {id: number}, showLoading: boolean = false): AxiosPromise<Resp<{flowList:{id: string, name: string}[],campaignList:{id: string, name: string}[], verifyDelete: boolean, deleteStatus: boolean }>> {
  return commonApi(params, 'cartsee.fenqun.delete.verifyFenqun', showLoading);
}

/**
 * 删除用户分群
 * @param params
 * @param showLoading
 */
export function deleteFenqun(params: {id: number}, showLoading: boolean = false): AxiosPromise<Resp<{deleteStatus: boolean}>> {
  return commonApi(params, 'cartsee.fenqun.deleteFenqun', showLoading);
}

/**
 * 用户群文件校验
 * @param params
 * @param showLoading
 */
export function checkFenqunFile(params: {url: string, name: string, fenqunId?: number}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.fenqun.check', showLoading);
}

/**
 * 创建用户群
 * @param params
 * @param showLoading
 */
export function createFenqun(params: {name: string, url: string, fenqunId?: number}, showLoading: boolean = false): AxiosPromise<Resp<{fenqunId: number}>> {
  return commonApi(params, 'cartsee.fenqun.upload', showLoading);
}

/**
 * 用户分群的用户信息
 * @param params
 * @param showLoading
 */
export function getFenqunContact(params: FenqunPageInfo, showLoading: boolean = false): AxiosPromise<Resp<TFenqunUserInfoVO[]>> {
  return commonApi(params, 'cartsee.fenqun.contact.page', showLoading);
}

/**
 * 上传记录列表
 * @param params
 * @param showLoading
 */
export function getFenqunUploadLog(params: {fenqunId: number}, showLoading: boolean = false): AxiosPromise<Resp<TFenqunRecordVO[]>> {
  return commonApi(params, 'cartsee.fenqun.uploadLog.list', showLoading);
}

/**
 * 发送验证邮件
 * @param params
 * @param showLoading
 */
export function sendVerifyEmail(params: {email: string}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.email.sendVerifyEmail', showLoading);
}

/**
 * 检查验证状态
 * @param params
 * @param showLoading
 */
export function verify(params: {email: string}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.email.verify', showLoading);
}

/**
 * 验证通过
 * @param params
 * @param showLoading
 */
export function verifySuccess(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.email.verifySuccess', showLoading);
}

/**
 * 模板列表
 * @param params
 * @param showLoading
 */
export function getStyleList(params: {}, showLoading: boolean = false): AxiosPromise<Resp<Style[]>> {
  return commonApi(params, 'cartsee.email.styleList', showLoading);
}

/**
 * 获取模板信息
 * @param params
 * @param showLoading
 */
export function getStyleInfo(params: {styleId: number}, showLoading: boolean = false): AxiosPromise<Resp<StyleInfo>> {
  return commonApi(params, 'cartsee.email.styleInfo', showLoading);
}

/**
 * 发送邮件
 * @param params
 * @param showLoading
 */
export function sendTestEmail(params: EmailSendReq, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.email.sendTestEmail', showLoading);
}

// /**
//  * 订阅
//  * @param params
//  * @param showLoading
//  */
// export function subscribeInterface(params: SubscribeReq, showLoading: boolean = false): AxiosPromise<Resp<SubscribeResp>> {
//   return commonApi(params, 'cartsee.contact.subscribe', showLoading);
// }

/**
 * 订阅
 * @param params
 * @param showLoading
 */
export async function subscribeInterface(params: any, showLoading: boolean = false) {
  // return commonApi(params, 'cartsee.contact.subscribe', showLoading);
    try {
    const url = isEnableNewService() ? 'https://static-forms.clink-lists.com/cartsee/form/subscribe' : 'https://cartsee-form-c.cartx.cloud/cartsee/form/subscribe';
    const method = 'post';

    // 添加表单字段

    const headers = {
      'Content-Type': 'application/json' // 使用form/data格式
    };

    const response =  service2.post('/cartsee/form/subscribe',params, {headers});
    return response;

    // 处理响应数据
    // console.log(response.data);
  } catch (error) {
    // 处理错误
    console.error(error);
  }
}
// /**
//  * 取消订阅
//  * @param params
//  * @param showLoading
//  */
// export function unsubscribeInterface(params: SubscribeReq, showLoading: boolean = false): AxiosPromise<Resp<SubscribeResp>> {
//   return commonApi(params, 'cartsee.contact.unsubscribe', showLoading);
// }

/**
 * 取消订阅
 * @param params
 * @param showLoading
 */
export function unsubscribeInterface(params: any, showLoading: boolean = false) {
     try {
    const url = isEnableNewService() ? 'https://static-forms.clink-lists.com/cartsee/form/unsubscribe' : 'https://cartsee-form-c.cartx.cloud/cartsee/form/unsubscribe';
    const method = 'post';

    // 添加表单字段

    const headers = {
      'Content-Type': 'application/json' // 使用form/data格式
    };

    const response =  service2.post('/cartsee/form/unsubscribe',params, {headers});
    return response;

    // 处理响应数据
    // console.log(response.data);
  } catch (error) {
    // 处理错误
    console.error(error);
  }
}

/**
 * 获取退订页面店铺信息
 * @param params
 * @param showLoading
 */
export function getUnsubscribleSite(params: any, showLoading: boolean = false) {
  try {
 // 添加表单字段

 const headers = {
   'Content-Type': 'application/json' // 使用form/data格式
 };

 const response =  service2.post('/cartsee/form/getCompanyInfo',params, {headers});
 return response;

 // 处理响应数据
 // console.log(response.data);
} catch (error) {
 // 处理错误
 console.error(error);
}
}

/**
 * 首页数据
 * @param params
 * @param showLoading
 */
export function reportDimension(params: EcharsDimension, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee-go.report.dimension', showLoading);
}
export function reportRank(params: EcharsDimension, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee-go.report.dimension', showLoading);
}
export function reportSummary(params: EcharsDimension, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee-go.report.dimension', showLoading);
}

/**
 * 店铺系列列表（按公司分页）
 * @param params
 * @param showLoading
 */
export function listByCompany(params: ListBy, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, CARTSEE_COLLECTION_PRODUCT_ACTION.collectionListByCompany, showLoading);
}

/**
 * 某系列下商品列表
 * @param params
 * @param showLoading
 */
export function listByCollection(params: ListBy, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, CARTSEE_COLLECTION_PRODUCT_ACTION.productListByCollection, showLoading);
}

/**
 * 系列搜索分页（collectionName、currentPage、pageSize、companyId 等由后端约定）
 * 网关 action：`cartsee.collection.listBySearch`（cartsee-front：`cartsee/collection/listBySearch`）
 */
export function collectionListBySearch(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, CARTSEE_COLLECTION_PRODUCT_ACTION.collectionListBySearch, showLoading);
}

/**
 * 店铺商品搜索（productName、productIds、分页等由后端约定）
 * 网关 action：`cartsee.product.listBySearch`（cartsee-front：`cartsee/product/listBySearch`）
 */
export function productListBySearch(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, CARTSEE_COLLECTION_PRODUCT_ACTION.productListBySearch, showLoading);
}

/**
 * 营销活动详情
 * @param params
 * @param showLoading
 */
export function getCampaignDetail(params: TCampaignIDRequest, showLoading: boolean = false): AxiosPromise<Resp<TCampaignSaveDetailRequest>> {
  return commonApi(params, 'cartsee.campaign.detail', showLoading);
}

/**
 * 复制营销活动详情
 * @param params
 * @param showLoading
 */
export function copyCampaignDetail(params: TCampaignIDRequest, showLoading: boolean = false): AxiosPromise<Resp<TCampaignSaveDetailRequest>> {
  return commonApi(params, 'cartsee.campaign.copy', showLoading);
}


/**
 * 营销活动列表
 * @param params
 * @param showLoading
 */
export function getCampaignList(params: PageInfo, showLoading: boolean = false): AxiosPromise<Resp<TCampaignVO[]>> {
  return commonApi(params, 'cartsee.campaign.list', showLoading);
}

/**
 * 保存营销活动草稿
 * @param params
 * @param showLoading
 */
export function saveCampaignDraft(params: TCampaignSaveDetailRequest, showLoading: boolean = false): AxiosPromise<Resp<TCampaignSaveDetailRequest>> {
  return commonApi(params, 'cartsee.campaign.saveDraftDetail', showLoading);
}

/**
 * 保存营销活动
 * @param params
 * @param showLoading
 */
export function saveCampaignDetail(params: TCampaignSaveDetailRequest, showLoading: boolean = false): AxiosPromise<Resp<TCampaignSaveDetailRequest>> {
  return commonApi(params, 'cartsee.campaign.saveDetail', showLoading);
}

/**
 * 发布营销活动
 * @param params
 * @param showLoading
 */
export function publishCampaignDetail(params: TCampaignIDRequest, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.campaign.detail.publish', showLoading);
}

/**
 * 停止营销活动
 * @param params
 * @param showLoading
 */
export function pauseCampaignDetail(params: TCampaignIDRequest, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.campaign.detail.pause', showLoading);
}

/**
 * 取消营销活动
 * @param params
 * @param showLoading
 */
export function cancelCampaignDetail(params: TCampaignIDRequest, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.campaign.detail.cancel', showLoading);
}

/**
 * 删除营销活动
 * @param params
 * @param showLoading
 */
export function deleteCampaignDetail(params: TCampaignIDRequest, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.campaign.detail.delete', showLoading);
}

/**
 * 创建转盘初始化信息
 * @param params
 * @param showLoading
 */
export function initWheelOfFortune(params: {}, showLoading: boolean = false): AxiosPromise<Resp<TFormSaveDetailRequest>> {
  return commonApi(params, 'cartsee.form.wheelOfFortune.initDetail', showLoading);
}

/**
 * 查看转盘信息
 * @param params
 * @param showLoading
 */
export function getWheelOfFortuneDetail(params: {id: string}, showLoading: boolean = false): AxiosPromise<Resp<TFormSaveDetailRequest>> {
  return commonApi(params, 'cartsee.form.detail', showLoading);
}

/**
 * 获取转盘列表
 * @param params
 * @param showLoading
 */
export function getWheelOfFortuneList(params?: PageInfo|any, showLoading: boolean = false): AxiosPromise<Resp<TFormVO[]>> {
  return commonApi(params, 'cartsee.form.list', showLoading);
}

/**
 * 查看分步信息
 * @param params
 *
 */
 export function getFormStepList(params: any, showLoading: boolean = false): AxiosPromise<Resp<TFormVO[]>> {
  return commonApi(params, 'cartsee.form.step.list', showLoading);
}

/**
 * 保存数据筛选项
 * @param params
 *
 */
 export function companyMeasureSave(params: any, showLoading: boolean = false): AxiosPromise<Resp<TFormVO[]>> {
  return commonApi(params, 'cartsee.companyMeasure.save', showLoading);
}

/**
 * 获取数据筛选项
 * @param params
 *
 */
 export function getCompanyMeasure(params: any, showLoading: boolean = false): AxiosPromise<Resp<TFormVO[]>> {
  return commonApi(params, 'cartsee.companyMeasure.getCompanyMeasure', showLoading);
}

/**
 * 获取公司创建弹窗类型tab权限
 * @param params
 *
 */
export function getTabAuthorityList(params: any, showLoading: boolean = false): AxiosPromise<Resp<TTabAuthVO>> {
  return commonApi(params, 'cartsee.form.getTabAuthorityList', showLoading);
}

/**
 * 判断是否安装了cartsee插件
 * @param params
 *
 */
export function getIsDeployJs(params: any, showLoading: boolean = false): AxiosPromise<Resp<TTabAuthVO>> {
  return commonApi(params, 'cartsee.form.isDeployJs', showLoading);
}

/**
 * 保存转盘信息
 * @param params
 * @param showLoading
 */
export function saveWheelOfFortune(params: TFormSaveDetailRequest, showLoading: boolean = false): AxiosPromise<Resp<TFormSaveDetailRequest>> {
  return commonApi(params, 'cartsee.form.wheelOfFortune.saveDetail', showLoading);
}

/**
 * 保存转盘草稿
 * @param params
 * @param showLoading
 */
export function saveWheelOfFortuneDraft(params: TFormSaveDetailRequest, showLoading: boolean = false): AxiosPromise<Resp<TFormSaveDetailRequest>> {
  return commonApi(params, 'cartsee.form.wheelOfFortune.saveDraftDetail', showLoading);
}

/**
 * 开启转盘
 * @param params
 * @param showLoading
 */
export function openWheelOfFortune(params: {id: string}, showLoading: boolean = false): AxiosPromise<Resp<void>> {
  return commonApi(params, 'cartsee.form.detail.open', showLoading);
}

/**
 * 关闭转盘
 * @param params
 * @param showLoading
 */
export function closeWheelOfFortune(params: {id: string}, showLoading: boolean = false): AxiosPromise<Resp<void>> {
  return commonApi(params, 'cartsee.form.detail.close', showLoading);
}


/**
 * 获取大转盘excel
 */
export function getWheelOfFortuneExcel(params: {id: string}): AxiosPromise<Resp<File>> {
  const token = getToken();
  const newParams = sign(params, token);
  const action = 'cartsee.form.detail.downloadSingupRecords'
  return axios2.post(
    getVueAppBaseApi() + `/api.json?action=${action}`,
    newParams,
    { headers: { token }, responseType: 'blob' }
  )
}


/**
 * 获取套餐列表
 */
export function getSubscriptionPlanList(params: {}, showLoading: boolean = false): AxiosPromise<Resp<SubscriptionPlanData>> {
  return commonApi(params, 'cartsee.subscriptionPlan.list', showLoading);
}

/**
 * 获取订阅套餐信息
 */
export function getSubscriptionPlan(params: SubscriptionPlanReq, showLoading: boolean = false): AxiosPromise<Resp<SubscriptionPlanResp>> {
  return commonApi(params, 'cartsee.subscriptionPlan.subscribe', showLoading);
}

/*
  获取账户信息
 */
export function getAccountInfo(params: any,showLoading=false ) {
  return commonApi(params, 'cartsee.company.account.detail', showLoading);
}


//flow策略器明细数据概览
export function getFlowStatistics(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.strategy.statistics', showLoading);
}

// 发送/送达/打开/点击/下单/退回/退订/投诉 明细tab
export function getFlowMeasureDetail(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.strategy.measureDetail', showLoading);
}
// campaign明细统计 发送/送达/打开/点击/下单/退回/退订/投诉 明细tab
export function getCampaignMeasureStatistics(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.campaign.measureStatistics', showLoading);
}
// campaign明细
export function getCampaignMeasureDetail(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.campaign.measureDetail', showLoading);
}

//订阅工具弹窗--保存草稿
export function saveDraftDetailPopWindow(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.popWindow.saveDraftDetail', showLoading);
}

//订阅工具弹窗--发布
export function saveDetailPopWindow(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.popWindow.saveDetail', showLoading);
}

//订阅工具弹窗--获取单个模板
export function getPopWindowTemplate(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.template', showLoading);
}

////订阅工具弹窗--编辑
export function getPopWindowDetail(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.detail', showLoading);
}
////订阅工具弹窗--删除
export function postPopupDelete(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.detail.delete', showLoading);
}
////订阅工具弹窗--复制
export function getPopWindowCopyDetail(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.copy', showLoading);
}
//订阅工具弹窗--查看模板列表
export function getPopWindowTemplateList(params: any, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.template.list', showLoading);
}

//订阅工具弹窗--订阅工具全局设置
export function setGlobalSetting(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.globalSetting.update', showLoading);
}

//订阅工具弹窗--获取订阅工具全局设置
export function getGlobalSetting(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.globalSetting.detail', showLoading);
}


//获取后端设置智能发送的阈值
export function getCompanyDetail(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.company.detail', showLoading);
}
//strategy 邮件点击分布
export function getEmailClickStrategy(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee-go.report.email-click-strategy', showLoading);
}

//campaign 邮件点击分布
export function getEmailClickCampaign(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee-go.report.email-click-campaign', showLoading);
}

//获取手机区号
export function getPhoneCodeCodeList(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.country.phone.code.codeList', showLoading);
}
//获取手机区号和国家
export function getCountryPhoneCodeCodeList(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.country.phone.code.codeLists', showLoading);
}
//获取用户的自定义属性列表
export function getContactProperty(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.contactProperty.list', showLoading);
}
//contactProperty-根据属性id获取用户自定义属性接口
export function getContactPropertyDetail(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.contactProperty.detail', showLoading);
}

///再营销模版列表
export function getflowList(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.flow.flowListByIds', showLoading);
}
///再营销模版列表
export function getCampaignFlowList(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.flow.campaignFlowList', showLoading);
}
///获取邮件点击url
export function getSuggestClickUrl(params: {}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.suggest.click.url', showLoading);
}

///cartsee/campaign/save/journeyBuilder
export function setJourneyBuilder(params: {id:string, category: string}, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.campaign.save.journeyBuilder', showLoading);
}

// 订单数据导出
export function exportDataToEmail(params: PMS): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.strategy.exportOrderDetail');
}

// 导出数据-订阅工具
export function exportDataToEmailWithsub(params: PMS): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.form.detail.exportSingupRecords',);
}

// 判断每天导出次数
export function downloadTimes(params: PMS): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.export.downLoadTimes');
}

/**
 * 兼容先安装APP后注册账号的新用户注册流程
 */
export function getRedirect(params: {shop:string | null, token: string|null, state: string|null, customField:string|null, }, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  return commonApi(params, 'passport.redirect', showLoading);
}
// Flow回溯
export function flowReply(params: PMS): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.flow.replay');
}
//dns提醒关闭
export function getGuideNoticeClose(params: {}): AxiosPromise<Resp<boolean>> {
  return commonApi(params, 'cartsee.guide.dns.notice.close');
}

// 判断新手指引图标是否显示
export function checkGuide(params: {}): AxiosPromise<Resp<any>> {
  return commonApi(params, 'cartsee.guide.show');
}
/**
 * 查询当权账期
 * @param params
 */
export function getCurrentBillDate(params: any) {
  return commonApi(params, 'cartsee.bill.getCurrentBillDate');
}

// 根据账期导出文件
export function exportFileByBillDate(params: any) {
  return commonApi(params, 'cartsee.bill.export');
}

// 菜单是否显示 对账周期菜单项
export function showBillDateMenu(params: any) {
  return commonApi(params, 'cartsee.permission.account');
}

export function getBrandMonitorEmails(params: any) {
  return commonApi(params, 'cartsee.brandMonitor.emails');
}

export function createABTest(params: any) {
  return commonApi(params, 'cartsee.form.ab.createTestGroup');
}

export function getAbTest(params: any) {
  return commonApi(params, 'cartsee.form.ab.testGroupDetail');
}

export function saveAbtestDraft(params: any) {
  return commonApi(params, 'cartsee.form.ab.saveDraftTestGroup');
}

export function changeAbtestScene(params: any) {
  return commonApi(params, 'cartsee.form.ab.switchScene');
}

export function remoteAbtestPop(params: any) {
  return commonApi(params, 'cartsee.form.ab.deleteTestForm');
}

export function getAllTypePop(params: any) {
  return commonApi(params, 'cartsee.form.ab.historyFormList');
}

export function createAbtestPop(params: any) {
  return commonApi(params, 'cartsee.form.ab.createTestForm');
}

export function publishAbtest(params: any) {
  return commonApi(params, 'cartsee.form.ab.saveTestGroup');
}

export function cancelAbtest(params: any) {
  return commonApi(params, 'cartsee.form.ab.cancelTestGroup');
}

export function abtestChooseWin(params: any) {
  return commonApi(params, 'cartsee.form.ab.chooseWinForm');
}

//获取最后一条消息状态
export function getLastMsgReadStatus(params: any) {
  return commonApi(params, 'cartsee.message.lastMsgReadStatus');
}
//获取最后一条消息数据
export function getLastMsg(params: any) {
  return commonApi(params, 'cartsee.message.lastMsg');
}
/** 获取icon素材库 */
export function getIconImageList(params: any) {
  return commonApi(params, 'cartsee.form.icon.list');
}

export interface Country {
  /**
   * CN
   */
  countryAbbreviation: string;
  /**
   * China
   */
  country: string;
  /**
   * 中国
   */
  countryName: string;
}
/** 获取国家 */
export function getCountryList(params: any): AxiosPromise<Resp<Country[]>>  {
  return commonApi(params, 'cartsee.country.code.codeLists');
}
